// @spec GHG-STR-018
'use client';

import { Link, createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import i18n from '@/lib/i18n';

export const Route = createFileRoute('/_authenticated/ghg/scope2')({
  beforeLoad: () => ({
    getTitle: () => i18n.t('routeTitles.scope2Emissions'),
  }),
  component: Scope2Page,
});

function Scope2Page() {
  const { t } = useTranslation('ghg');
  return (
    <div className="p-8">
      <div className="mx-auto max-w-3xl space-y-6">
        <header>
          <h1 className="text-3xl font-semibold text-foreground">{t('scope2Page.heading')}</h1>
          <p className="mt-2 text-muted-foreground">
            {t('scope2Page.description')}
          </p>
        </header>

        <Card>
          <CardHeader>
            <CardTitle>{t('scope2Page.cardTitle_dataEntry')}</CardTitle>
            <CardDescription>{t('scope2Page.cardDesc_dataEntry')}</CardDescription>
          </CardHeader>
          <CardContent className="space-y-4">
            <p className="text-sm text-muted-foreground">
              {t('scope2Page.dataEntryInstructions')}
            </p>
            <div className="flex flex-wrap gap-3">
              <Button asChild variant="outline">
                <Link to="/ghg/activity-data">{t('scope2Page.btn_goToAIAdvisor')}</Link>
              </Button>
              <Button asChild variant="outline">
                <Link to="/ghg/emission-factors">{t('scope2Page.btn_goToEmissionFactors')}</Link>
              </Button>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
